<template>
  <span :class="['eui-a-badge',
    color ? `-${color}`: '',
    { 'active': content > 0 },
    { '-inverted': inverted },
    { '-notification': notification }]">
    <template v-if="content < max">{{ content }}</template>
    <template v-else>+{{ max }}</template>
  </span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    content: Number,
    max: {
      type: Number,
      default: 99,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
    notification: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
      validator(value) {
        // La valeur passée doit être l'une de ces chaines de caractères
        return ['primary', 'success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
  },
};
</script>
